import { Strike as TiptapStrike } from '@tiptap/extension-strike'
import { StrikeActionButton } from '@/tiptap/extensions/components/ActionButton'

export default TiptapStrike.extend({
  addOptions() {
    return {
      ...(this.parent?.() || {}),
      button: ({ editor, t }) => ({
        component: StrikeActionButton,
        componentProps: { editor, t },
      }),
    }
  },
})
